/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CarriedInterestAdjustmentByTypeDeleteParams
} from '../../model/carriedInterestAdjustmentByTypeDeleteParams'
import type {
  CarriedInterestAdjustmentCreateUpdateDataRequest
} from '../../model/carriedInterestAdjustmentCreateUpdateDataRequest'
import type {
  FundFamilySubEventData
} from '../../model/fundFamilySubEventData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  InvestmentWaterfallClassificationBulkUpdateDataRequest
} from '../../model/investmentWaterfallClassificationBulkUpdateDataRequest'
import type {
  InvestmentWaterfallClassificationData
} from '../../model/investmentWaterfallClassificationData'
import type {
  InvestmentWaterfallClassificationDataList
} from '../../model/investmentWaterfallClassificationDataList'
import type {
  InvestmentWaterfallClassificationEditDataRequest
} from '../../model/investmentWaterfallClassificationEditDataRequest'
import type {
  WaterfallRunData
} from '../../model/waterfallRunData'
import type {
  WaterfallRunPrefOnDebtDataRequest
} from '../../model/waterfallRunPrefOnDebtDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets a fund family sub event
 */
export const fundFamilySubEventRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilySubEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilySubEventRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}`] as const;
    }

    
export const getFundFamilySubEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>> = ({ signal }) => fundFamilySubEventRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>>
export type FundFamilySubEventRetrieveQueryError = unknown

export const useFundFamilySubEventRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySubEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>> = ({ signal }) => fundFamilySubEventRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>>
export type FundFamilySubEventRetrieveSuspenseQueryError = unknown

export const useFundFamilySubEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySubEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySubEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
              queryFn: () => fundFamilySubEventRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Deletes a fund family sub event
 */
export const fundFamilySubEventDelete = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}`, method: 'DELETE'
    },
      options);
    }
  


export const getFundFamilySubEventDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilySubEventDelete>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId} = props ?? {};

          return  fundFamilySubEventDelete(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilySubEventDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventDelete>>>
    
    export type FundFamilySubEventDeleteMutationError = unknown

    export const useFundFamilySubEventDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilySubEventDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete carried interest adjustment by type for waterfall run
 */
export const carriedInterestAdjustmentByTypeDelete = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: CarriedInterestAdjustmentByTypeDeleteParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/carry-adjustment-by-type/delete/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getCarriedInterestAdjustmentByTypeDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentByTypeDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;params?: CarriedInterestAdjustmentByTypeDeleteParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentByTypeDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;params?: CarriedInterestAdjustmentByTypeDeleteParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof carriedInterestAdjustmentByTypeDelete>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;params?: CarriedInterestAdjustmentByTypeDeleteParams}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,params} = props ?? {};

          return  carriedInterestAdjustmentByTypeDelete(fundFamilyId,fundFamilySubEventId,fundEntityId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CarriedInterestAdjustmentByTypeDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof carriedInterestAdjustmentByTypeDelete>>>
    
    export type CarriedInterestAdjustmentByTypeDeleteMutationError = unknown

    export const useCarriedInterestAdjustmentByTypeDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentByTypeDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;params?: CarriedInterestAdjustmentByTypeDeleteParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCarriedInterestAdjustmentByTypeDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create or update carried interest adjustment for waterfall run
 */
export const carriedInterestAdjustmentCreateOrUpdate = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    carriedInterestAdjustmentCreateUpdateDataRequest: CarriedInterestAdjustmentCreateUpdateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/carry-adjustment/create-or-update/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: carriedInterestAdjustmentCreateUpdateDataRequest
    },
      options);
    }
  


export const getCarriedInterestAdjustmentCreateOrUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentCreateOrUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: CarriedInterestAdjustmentCreateUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentCreateOrUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: CarriedInterestAdjustmentCreateUpdateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof carriedInterestAdjustmentCreateOrUpdate>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: CarriedInterestAdjustmentCreateUpdateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,data} = props ?? {};

          return  carriedInterestAdjustmentCreateOrUpdate(fundFamilyId,fundFamilySubEventId,fundEntityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CarriedInterestAdjustmentCreateOrUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof carriedInterestAdjustmentCreateOrUpdate>>>
    export type CarriedInterestAdjustmentCreateOrUpdateMutationBody = CarriedInterestAdjustmentCreateUpdateDataRequest
    export type CarriedInterestAdjustmentCreateOrUpdateMutationError = unknown

    export const useCarriedInterestAdjustmentCreateOrUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentCreateOrUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: CarriedInterestAdjustmentCreateUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCarriedInterestAdjustmentCreateOrUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete ALL carried interest adjustments for waterfall run
 */
export const carriedInterestAdjustmentDelete = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/carry-adjustment/delete/`, method: 'DELETE'
    },
      options);
    }
  


export const getCarriedInterestAdjustmentDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof carriedInterestAdjustmentDelete>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  carriedInterestAdjustmentDelete(fundFamilyId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CarriedInterestAdjustmentDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof carriedInterestAdjustmentDelete>>>
    
    export type CarriedInterestAdjustmentDeleteMutationError = unknown

    export const useCarriedInterestAdjustmentDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof carriedInterestAdjustmentDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCarriedInterestAdjustmentDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get waterfall classifications for waterfall run
 */
export const investmentWaterfallClassificationsList = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestmentWaterfallClassificationDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestmentWaterfallClassificationsListQueryKey = (fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications/`] as const;
    }

    
export const getInvestmentWaterfallClassificationsListQueryOptions = <TData = Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentWaterfallClassificationsListQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>> = ({ signal }) => investmentWaterfallClassificationsList(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentWaterfallClassificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>>
export type InvestmentWaterfallClassificationsListQueryError = unknown

export const useInvestmentWaterfallClassificationsList = <TData = Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentWaterfallClassificationsListQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentWaterfallClassificationsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentWaterfallClassificationsListQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>> = ({ signal }) => investmentWaterfallClassificationsList(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentWaterfallClassificationsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>>
export type InvestmentWaterfallClassificationsListSuspenseQueryError = unknown

export const useInvestmentWaterfallClassificationsListSuspense = <TData = Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentWaterfallClassificationsListSuspenseQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentWaterfallClassificationsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentWaterfallClassificationsListQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId),
              queryFn: () => investmentWaterfallClassificationsList(fundFamilyId,fundFamilySubEventId,fundEntityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets hybrid waterfall classification summary table data
 */
export const waterfallInvestmentClassificationSummaryTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications-summary-table`, method: 'GET', signal
    },
      options);
    }
  

export const getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications-summary-table`] as const;
    }

    
export const getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>> = ({ signal }) => waterfallInvestmentClassificationSummaryTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestmentClassificationSummaryTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>>
export type WaterfallInvestmentClassificationSummaryTableDataRetrieveQueryError = unknown

export const useWaterfallInvestmentClassificationSummaryTableDataRetrieve = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallInvestmentClassificationSummaryTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>> = ({ signal }) => waterfallInvestmentClassificationSummaryTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestmentClassificationSummaryTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>>
export type WaterfallInvestmentClassificationSummaryTableDataRetrieveSuspenseQueryError = unknown

export const useWaterfallInvestmentClassificationSummaryTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationSummaryTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestmentClassificationSummaryTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallInvestmentClassificationSummaryTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallInvestmentClassificationSummaryTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId),
              queryFn: () => waterfallInvestmentClassificationSummaryTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets hybrid waterfall classification table data
 */
export const waterfallInvestmentClassificationTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications-table`, method: 'GET', signal
    },
      options);
    }
  

export const getWaterfallInvestmentClassificationTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications-table`] as const;
    }

    
export const getWaterfallInvestmentClassificationTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestmentClassificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>> = ({ signal }) => waterfallInvestmentClassificationTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestmentClassificationTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>>
export type WaterfallInvestmentClassificationTableDataRetrieveQueryError = unknown

export const useWaterfallInvestmentClassificationTableDataRetrieve = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestmentClassificationTableDataRetrieveQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallInvestmentClassificationTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestmentClassificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>> = ({ signal }) => waterfallInvestmentClassificationTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestmentClassificationTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>>
export type WaterfallInvestmentClassificationTableDataRetrieveSuspenseQueryError = unknown

export const useWaterfallInvestmentClassificationTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestmentClassificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestmentClassificationTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilySubEventId,fundEntityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallInvestmentClassificationTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallInvestmentClassificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilySubEventId,fundEntityId),
              queryFn: () => waterfallInvestmentClassificationTableDataRetrieve(fundFamilyId,fundFamilySubEventId,fundEntityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates a list of waterfall classifications data
 */
export const investmentWaterfallClassificationBulkUpdate = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    investmentWaterfallClassificationBulkUpdateDataRequest: InvestmentWaterfallClassificationBulkUpdateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestmentWaterfallClassificationDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications/bulk-update/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investmentWaterfallClassificationBulkUpdateDataRequest
    },
      options);
    }
  


export const getInvestmentWaterfallClassificationBulkUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationBulkUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: InvestmentWaterfallClassificationBulkUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationBulkUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: InvestmentWaterfallClassificationBulkUpdateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentWaterfallClassificationBulkUpdate>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: InvestmentWaterfallClassificationBulkUpdateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,data} = props ?? {};

          return  investmentWaterfallClassificationBulkUpdate(fundFamilyId,fundFamilySubEventId,fundEntityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentWaterfallClassificationBulkUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof investmentWaterfallClassificationBulkUpdate>>>
    export type InvestmentWaterfallClassificationBulkUpdateMutationBody = InvestmentWaterfallClassificationBulkUpdateDataRequest
    export type InvestmentWaterfallClassificationBulkUpdateMutationError = unknown

    export const useInvestmentWaterfallClassificationBulkUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationBulkUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: InvestmentWaterfallClassificationBulkUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentWaterfallClassificationBulkUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update waterfall classification
 */
export const investmentWaterfallClassificationUpdate = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    id: string,
    investmentWaterfallClassificationEditDataRequest: InvestmentWaterfallClassificationEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestmentWaterfallClassificationData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-classifications/update/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: investmentWaterfallClassificationEditDataRequest
    },
      options);
    }
  


export const getInvestmentWaterfallClassificationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;id: string;data: InvestmentWaterfallClassificationEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;id: string;data: InvestmentWaterfallClassificationEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentWaterfallClassificationUpdate>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;id: string;data: InvestmentWaterfallClassificationEditDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,id,data} = props ?? {};

          return  investmentWaterfallClassificationUpdate(fundFamilyId,fundFamilySubEventId,fundEntityId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentWaterfallClassificationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof investmentWaterfallClassificationUpdate>>>
    export type InvestmentWaterfallClassificationUpdateMutationBody = InvestmentWaterfallClassificationEditDataRequest
    export type InvestmentWaterfallClassificationUpdateMutationError = unknown

    export const useInvestmentWaterfallClassificationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentWaterfallClassificationUpdate>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;id: string;data: InvestmentWaterfallClassificationEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentWaterfallClassificationUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates an instance of a waterfall run or updates the waterfall run if it already exists
 */
export const waterfallRunUpsert = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    waterfallRunPrefOnDebtDataRequest: WaterfallRunPrefOnDebtDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: waterfallRunPrefOnDebtDataRequest
    },
      options);
    }
  


export const getWaterfallRunUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallRunUpsert>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,data} = props ?? {};

          return  waterfallRunUpsert(fundFamilyId,fundFamilySubEventId,fundEntityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallRunUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallRunUpsert>>>
    export type WaterfallRunUpsertMutationBody = WaterfallRunPrefOnDebtDataRequest
    export type WaterfallRunUpsertMutationError = unknown

    export const useWaterfallRunUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallRunUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates a new waterfall run and runs it
 */
export const waterfallCreateAndRun = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    waterfallRunPrefOnDebtDataRequest: WaterfallRunPrefOnDebtDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/create-and-run/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: waterfallRunPrefOnDebtDataRequest
    },
      options);
    }
  


export const getWaterfallCreateAndRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallCreateAndRun>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId,data} = props ?? {};

          return  waterfallCreateAndRun(fundFamilyId,fundFamilySubEventId,fundEntityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallCreateAndRunMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallCreateAndRun>>>
    export type WaterfallCreateAndRunMutationBody = WaterfallRunPrefOnDebtDataRequest
    export type WaterfallCreateAndRunMutationError = unknown

    export const useWaterfallCreateAndRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string;data: WaterfallRunPrefOnDebtDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallCreateAndRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Removes a waterfall run from a fund family sub event
 */
export const waterfallRunDelete = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/delete/`, method: 'DELETE'
    },
      options);
    }
  


export const getWaterfallRunDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallRunDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallRunDelete>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  waterfallRunDelete(fundFamilyId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallRunDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallRunDelete>>>
    
    export type WaterfallRunDeleteMutationError = unknown

    export const useWaterfallRunDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunDelete>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallRunDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Triggers a waterfall run for a specific waterfall
 */
export const runWaterfall = (
    fundFamilyId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/run/`, method: 'POST'
    },
      options);
    }
  


export const getRunWaterfallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runWaterfall>>, {fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  runWaterfall(fundFamilyId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RunWaterfallMutationResult = NonNullable<Awaited<ReturnType<typeof runWaterfall>>>
    
    export type RunWaterfallMutationError = unknown

    export const useRunWaterfall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getRunWaterfallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    